// extracted by mini-css-extract-plugin
export default {"button":"change-region-button-module--button--40c4c","buttonIcon":"change-region-button-module--buttonIcon--6b590","buttonLink":"change-region-button-module--buttonLink--cf746"};